<div class="flex">
  <div class="pr-3" style="max-width: 48%">
    <jml-lib-dynamic-table
      #notesTable
      *ngIf="noteTableData"
      [tableData]="noteTableData"
      (entitySelection)="noteSelected($event)"
      [isRootEntity]="false"
    ></jml-lib-dynamic-table>
  </div>
  <div *ngIf="selectedNote; else newNote" class="flex-grow-1;">
    <div class="p-inputgroup">
      <input type="text" style="border-bottom-left-radius: 0" pInputText [(ngModel)]="selectedNote.subject" />
      <button type="button" pButton icon="pi pi-trash" class="p-button-warning" (click)="removeNote()"></button>
      <button
        type="button"
        style="border-bottom-right-radius: 0"
        pButton
        icon="pi pi-save"
        class="p-button-success"
        (click)="saveNote()"
      ></button>
    </div>
    <p-editor [(ngModel)]="selectedNote.note" [style]="{ height: '170px' }"></p-editor>
  </div>
  <ng-template #newNote>
    <div class="flex-grow-1;" class="editor-placeholder" (click)="createEmptyNote()">
      <i class="pi pi-plus new-note-icon"></i>
    </div>
  </ng-template>
</div>
